import React from "react";
import { QuizSlider } from "../QuizSlider";
import { DLSButton } from "~/components/shared/DLSButton";
import { useQuizTracker } from "~/hooks/useQuizTracker";
import { QUIZ_EVENTS, sliderBucket } from "~/utils/analytics/quizEvents";
import * as styles from "./index.module.scss";

export function SliderQuestion({
  answerValue,
  question: { id, labels, Image, title },
  isLastQuestion = false,
  onClickButton,
  onChangeValue,
  useRange = false,
  hiddenContinueButton = false,
}) {
  const buttonCopy = isLastQuestion ? "Results" : "Continue";
  const track = useQuizTracker();

  /**
   * Handle the continue button click.
   *
   * Emits the slider answer and calls the onClickButton callback. The useRange
   * branch (quiz_range_answered) is intentionally not instrumented: no question
   * in the current quiz sets useRange, so it is dead code.
   */
  const onContinue = () => {
    if (!useRange) {
      track(QUIZ_EVENTS.SLIDER_ANSWERED, {
        // Legacy contract: property = question id, value, and bucket (label
        // derived from the value). The raw labels array is not emitted — it
        // does not segment. step_id kept as additive.
        property: id,
        value: answerValue,
        bucket: sliderBucket(answerValue, labels),
        step_id: id,
        quiz_question_text: title?.toLowerCase(),
      });
    }

    onClickButton(false);
  };

  return (
    <div
      className={styles.sliderQuestionItem}
      data-testid="slider-question-container"
    >
      {Image && (
        <div className={styles.imgContainer}>
          <Image value={answerValue} />
        </div>
      )}
      <div className={styles.sliderContainer}>
        <QuizSlider
          value={answerValue}
          onChange={onChangeValue}
          options={labels}
          useRange={useRange}
        />
      </div>
      {!hiddenContinueButton && (
        <div className={styles.buttonContainer}>
          <DLSButton
            customClass={styles.quizButton}
            type="button"
            onClick={onContinue}
            data-testid={buttonCopy.toLowerCase()}
          >
            {buttonCopy}
          </DLSButton>
        </div>
      )}
    </div>
  );
}
